import script from "./PatrimonioEuropeoView.vue?vue&type=script&setup=true&lang=js"
export * from "./PatrimonioEuropeoView.vue?vue&type=script&setup=true&lang=js"

import "./PatrimonioEuropeoView.vue?vue&type=style&index=0&id=e1d34e20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1d34e20"]])

export default __exports__